import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { VehicleDetailsActions } from '../constants/vehicle_details/vehicle_details_actions';

class VehicleDetailsStoreClass extends ReduceStore {
    getInitialState() {
        return {
            loadingVehicleData: false,
            vehicleData: null,
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.VEHICLE_DETAILS_ACTION) {
            switch (action.type) {
                case VehicleDetailsActions.SET_VEHICLE_DATA:
                    state.loadingVehicleData = false;
                    state.vehicleData = action.payload;

                    this.__emitChange();
                    break;

                case VehicleDetailsActions.LOAD_VEHICLE_DATA_ACTION:
                    state.loadingVehicleData = true;
                    this.__emitChange();
                    break;

            }
        }

        return state;
    }
}

const VehicleDetailsStore = new VehicleDetailsStoreClass(Dispatcher);
export { VehicleDetailsStore };